<template>
  <div class="exportPdf">
    <div class="message">
      <div class="heading-msg">
        <br />
        <span class="br">
          {{ text.contact }}
          <br class="next-line" />
          {{ text.assistanceBeforeForm }}
          <a
            style="padding: 0px 0px 0px 1px"
            :href="text.urls.requestForm"
            target="_blank"
          >
            <u>{{ text.requestFormLabel }}</u></a
          >
          {{ text.assistanceBeforeLocator }}
          <a :href="text.urls.resellerLocator || undefined" target="_blank">
            <u>{{ text.resellerLocatorLabel }}</u></a
          >
          {{ text.assistanceAfterLocator }}
        </span>
      </div>
    </div>

    <img
      @click="
        show = 'true';
        downloadPdf();
      "
      alt="App Detail Pdf"
      src="../../assets/images/icons/pdf.png"
    />
    <b-modal
      v-model="show"
      title="Your PDF is being downloaded"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
    >
      <template v-slot:modal-footer>
        <div class="w-100" style="display: flex; justify-content: center">
          <b-button
            variant="success"
            size="sm"
            class="float-right btn"
            style="margin: 0 10px"
            @click="show = false"
          >
            Ok
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import ApiSvc from "../../js/ApiSvc";
import { API, LICENSE_TYPE } from "../../js/Constants.js";
import { PdfConstants, WelcomeText } from "../../js/PdfConstants";
import {
  PDF_FONT,
  pdfColor,
  registerPdfFonts,
  loadLogoDataUrl,
} from "../../js/pdfAssets";
export default {
  name: "appDetail-pdf",
  data() {
    return {
      text: WelcomeText,
      logoDataUrl: null,
      appInfoData: {},
      yPos: 0,
      lineHeight: 0,
      height: 0,
      width: 0,
      mode: "",
      show: false,
      variants: ["primary", "success"],
      headerBgVariant: "primary",
      headerTextVariant: "light",
      pdfMode: "true",
    };
  },
  props: {
    resourceId: {
      type: String,
    },
  },

  methods: {
    downloadPdf() {
      ApiSvc.requestForPdf(
        ["/appinfos/${id}/appinfodetails", [this.resourceId]],
        API.GET
      )
        .then((res) => res.data)
        .then(async (res) => {
          this.appInfoData = res;

          const doc = new jsPDF(this.mode, "mm", "a4", true);
          const [, logoDataUrl] = await Promise.all([
            registerPdfFonts(doc),
            loadLogoDataUrl("hpPrimaryTint0"),
          ]);
          this.logoDataUrl = logoDataUrl;
          doc.setFont(PDF_FONT, "normal");
          this.displayAppLevelContent(doc);
          this.addFooters(doc);
          doc.save(`${this.appInfoData.name}.pdf`);
        })
        .catch((err) => {
          console.log("Exception: ", err);
        });
    },
    addFooters(doc) {
      doc.setFont(PDF_FONT, "normal");
      doc.setFontSize(8);
      doc.setFontSize(8);
      let date = new Date();
      doc.text(`Date: ${date.toString()}`, 75, this.height - 57 + 25);
      var footerText = PdfConstants.footerCopyRight;
      var footerTextWidth = doc.splitTextToSize(footerText, this.width - 85);
      doc.text(footerTextWidth, 75, this.height - 57 + 30);

      doc.addImage(this.logoDataUrl, "PNG", 7, 270, 15, 15);
    },
    displayAppLevelContent(doc) {
      this.width = doc.internal.pageSize.getWidth();
      this.height = doc.internal.pageSize.getHeight();
      this.yPos = 10;
      doc.setFillColor(...pdfColor("hpPrimaryTint2"));
      doc.rect(0, 0, 70, 15, "F");
      doc.setFont(PDF_FONT, "normal");
      doc.text("HP APPS CATALOG", 7, this.yPos);
      let img = document.createElement("img");
      doc.setFillColor(...pdfColor("hpPrimaryTint1"));
      doc.rect(0, 15, 70, 30, "F");
      if (this.appInfoData.appImageUrl) {
        img.src = `data:image/png;base64,${this.appInfoData.appImageUrl}`;
        doc.addImage(img, "PNG", 7, this.yPos + 10, 15, 15);
      }

      this.yPos = this.yPos + 40;
      doc.setFont(PDF_FONT, "bold");
      doc.setFontSize(25);
      doc.setFillColor(...pdfColor("hpPrimaryTint0"));
      doc.rect(0, 40, 70, 280, "F");
      doc.setFillColor(...pdfColor("hpWhite"));
      doc.rect(70, 0, 210, 300, "F");
      this.lineHeight =
        doc.getLineHeight(this.appInfoData.name) / doc.internal.scaleFactor;
      this.yPos += this.lineHeight + 15;
      this.checkHeight(doc);
      doc.setFontSize(10);
      doc.setFont(PDF_FONT, "normal");
      doc.setTextColor(...pdfColor("hpBlack"));
      var lMargin = 7;
      var rMargin = 150;
      var pdfInMM = 220;
      var paragraph =
        "Contact your HP representative for more information on how to purchase HP Workpath apps.";
      var lines = doc.splitTextToSize(paragraph, pdfInMM - lMargin - rMargin);
      doc.text(lMargin, this.yPos + 5, lines);
      var name = this.appInfoData.name;
      doc.setFontSize(25);
      var line = doc.splitTextToSize(name, pdfInMM - lMargin - rMargin);
      doc.text(lMargin, this.yPos - 25, line);
      this.yPos += this.lineHeight + 10;
      doc.setDrawColor(...pdfColor("hpBlack"));
      doc.setLineWidth(0.4);
      doc.line(7, this.yPos, this.width - 145, this.yPos);
      this.yPos += this.lineHeight - 4;
      doc.setFontSize(10);
      doc.setTextColor(...pdfColor("hpBlack"));
      doc.setFont(PDF_FONT, "normal");
      doc.text("Offered By", 7, this.yPos);
      this.yPos += this.lineHeight - 6;
      doc.setFontSize(10);
      doc.setFont(PDF_FONT, "normal");
      doc.setTextColor(...pdfColor("hpBlack"));
      doc.text(this.appInfoData.vendorName, 7, this.yPos);

      this.yPos += this.lineHeight - 2;
      doc.setDrawColor(...pdfColor("hpBlack"));
      doc.setLineWidth(0.4);
      doc.line(7, this.yPos, this.width - 145, this.yPos);
      this.yPos += this.lineHeight - 4;
      doc.setFontSize(10);
      doc.setTextColor(...pdfColor("hpBlack"));
      doc.setFont(PDF_FONT, "normal");
      doc.text("License type", 7, this.yPos);
      this.yPos += this.lineHeight - 6;
      doc.setFontSize(10);
      doc.setFont(PDF_FONT, "normal");
      doc.setTextColor(...pdfColor("hpBlack"));
      doc.text(LICENSE_TYPE.fromVendor(this.appInfoData.vendorName), 7, this.yPos);

      this.yPos += this.lineHeight - 2;
      doc.setDrawColor(...pdfColor("hpBlack"));
      doc.setLineWidth(0.4);
      doc.line(7, this.yPos, this.width - 145, this.yPos);

      this.yPos += this.lineHeight - 4;
      doc.setFontSize(10);
      doc.setTextColor(...pdfColor("hpBlack"));
      doc.setFont(PDF_FONT, "normal");
      doc.text("Support", 7, this.yPos);
      this.yPos += this.lineHeight - 6;
      doc.setFontSize(10);
      doc.setFont(PDF_FONT, "normal");
      doc.setTextColor(...pdfColor("hpPrimary"));
      doc.textWithLink("Visit support website", 7, this.yPos, {
        url: this.appInfoData.webSite,
      });
      let index = this.appInfoData.resourceUrInfolList.length;
      if (this.appInfoData.resourceUrInfolList.length <= 1) {
        this.yPos = this.yPos + this.lineHeight - 200;
        let img = document.createElement("img");
        img.src = `data:image/png;base64,${this.appInfoData.resourceUrInfolListData[index]}`;
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[0],
          "PNG",
          75,
          this.yPos + 55,
          130,
          100,
          undefined,
          "FAST"
        );

        this.yPos = this.yPos + this.lineHeight + 170;
        this.checkHeight(doc);
        doc.setFontSize(18);
        doc.setTextColor(...pdfColor("hpDeeperGray"));
        doc.text("Description", 75, this.yPos);

        this.yPos = this.yPos + this.lineHeight - 5;
        doc.setFontSize(10);
        doc.setTextColor(...pdfColor("hpBlack"));
        let description = this.appInfoData.description.replaceAll(
          new RegExp(/[•\t+]/g),
          " "
        );
        let splittedText = doc.splitTextToSize(description, this.width - 85);
        for (let i = 0; i < splittedText.length; i++) {
          this.lineHeight =
            doc.getLineHeight(splittedText[0]) / doc.internal.scaleFactor;
          this.checkHeight(doc);
          if (
            splittedText[i] !== String.fromCharCode(160) &&
            splittedText[i].length
          ) {
            this.yPos = this.yPos + this.lineHeight;
            doc.text(splittedText[i], 75, this.yPos);
          }
        }
      } else if (this.appInfoData.resourceUrInfolList.length <= 2) {
        this.yPos = this.yPos + this.lineHeight - 150;
        let img = document.createElement("img");
        img.src = `data:image/png;base64,${this.appInfoData.resourceUrInfolListData[index]}`;
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[0],
          "PNG",
          73,
          this.yPos,
          65,
          50,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[1],
          "PNG",
          142,
          this.yPos,
          65,
          50,
          undefined,
          "FAST"
        );

        this.yPos = this.yPos + this.lineHeight + 130;
        this.checkHeight(doc);
        doc.setFontSize(18);
        doc.setTextColor(...pdfColor("hpDeeperGray"));
        doc.text("Description", 75, this.yPos);

        this.yPos = this.yPos + this.lineHeight - 5;
        doc.setFontSize(10);
        doc.setTextColor(...pdfColor("hpBlack"));
        let description = this.appInfoData.description.replaceAll(
          new RegExp(/[•\t+]/g),
          " "
        );
        let splittedText = doc.splitTextToSize(description, this.width - 85);
        for (let i = 0; i < splittedText.length; i++) {
          this.lineHeight =
            doc.getLineHeight(splittedText[0]) / doc.internal.scaleFactor;
          this.checkHeight(doc);
          if (
            splittedText[i] !== String.fromCharCode(160) &&
            splittedText[i].length
          ) {
            this.yPos = this.yPos + this.lineHeight;
            doc.text(splittedText[i], 75, this.yPos);
          }
        }
      } else if (this.appInfoData.resourceUrInfolList.length <= 3) {
        this.yPos = this.yPos + this.lineHeight - 150;
        let img = document.createElement("img");
        img.src = `data:image/png;base64,${this.appInfoData.resourceUrInfolListData[index]}`;
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[0],
          "PNG",
          73,
          this.yPos,
          65,
          50,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[1],
          "PNG",
          142,
          this.yPos,
          65,
          50,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[2],
          "PNG",
          73,
          this.yPos + 52,
          65,
          50,
          undefined,
          "FAST"
        );
        this.yPos = this.yPos + this.lineHeight + 125;
        this.checkHeight(doc);
        doc.setFontSize(18);
        doc.setTextColor(...pdfColor("hpDeeperGray"));
        doc.text("Description", 75, this.yPos);

        this.yPos = this.yPos + this.lineHeight - 5;
        doc.setFontSize(10);
        doc.setTextColor(...pdfColor("hpBlack"));
        let description = this.appInfoData.description.replaceAll(
          new RegExp(/[•\t+]/g),
          ""
        );
        let splittedText = doc.splitTextToSize(description, this.width - 85);
        for (let i = 0; i < splittedText.length; i++) {
          this.lineHeight =
            doc.getLineHeight(splittedText[0]) / doc.internal.scaleFactor;
          this.checkHeight(doc);
          if (
            splittedText[i] !== String.fromCharCode(160) &&
            splittedText[i].length
          ) {
            this.yPos = this.yPos + this.lineHeight;
            doc.text(splittedText[i], 75, this.yPos);
          }
        }
      } else if (this.appInfoData.resourceUrInfolList.length <= 4) {
        this.yPos = this.yPos + this.lineHeight - 150;
        let img = document.createElement("img");
        img.src = `data:image/png;base64,${this.appInfoData.resourceUrInfolListData[index]}`;
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[0],
          "PNG",
          73,
          this.yPos,
          65,
          50,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[1],
          "PNG",
          142,
          this.yPos,
          65,
          50,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[2],
          "PNG",
          73,
          this.yPos + 52,
          65,
          50,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[3],
          "PNG",
          142,
          this.yPos + 52,
          65,
          50,
          undefined,
          "FAST"
        );
        this.yPos = this.yPos + this.lineHeight + 125;
        this.checkHeight(doc);
        doc.setFontSize(18);
        doc.setTextColor(...pdfColor("hpDeeperGray"));
        doc.text("Description", 75, this.yPos);

        this.yPos = this.yPos + this.lineHeight - 5;
        doc.setFontSize(10);
        doc.setTextColor(...pdfColor("hpBlack"));
        let description = this.appInfoData.description.replaceAll(
          new RegExp(/[•\t+]/g),
          " "
        );
        let splittedText = doc.splitTextToSize(description, this.width - 85);
        for (let i = 0; i < splittedText.length; i++) {
          this.lineHeight =
            doc.getLineHeight(splittedText[0]) / doc.internal.scaleFactor;
          this.checkHeight(doc);
          if (
            splittedText[i] !== String.fromCharCode(160) &&
            splittedText[i].length
          ) {
            this.yPos = this.yPos + this.lineHeight;
            doc.text(splittedText[i], 75, this.yPos);
          }
        }
      } else if (this.appInfoData.resourceUrInfolList.length <= 5) {
        this.yPos = this.yPos + this.lineHeight - 150;
        let img = document.createElement("img");
        img.src = `data:image/png;base64,${this.appInfoData.resourceUrInfolListData[index]}`;
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[0],
          "PNG",
          75,
          this.yPos,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[1],
          "PNG",
          142,
          this.yPos,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[2],
          "PNG",
          75,
          this.yPos + 48,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[3],
          "PNG",
          142,
          this.yPos + 48,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[4],
          "PNG",
          75,
          this.yPos + 96,
          63,
          47,
          undefined,
          "FAST"
        );
        this.yPos = this.yPos + this.lineHeight + 142;
        this.checkHeight(doc);
        doc.setFontSize(18);
        doc.setTextColor(...pdfColor("hpDeeperGray"));
        doc.text("Description", 75, this.yPos);

        this.yPos = this.yPos + this.lineHeight - 7;
        doc.setFontSize(10);
        doc.setTextColor(...pdfColor("hpBlack"));
        let description = this.appInfoData.description.replaceAll(
          new RegExp(/[•\t+]/g),
          " "
        );
        let splittedText = doc.splitTextToSize(description, this.width - 85);
        for (let i = 0; i < splittedText.length; i++) {
          this.lineHeight =
            doc.getLineHeight(splittedText[0]) / doc.internal.scaleFactor;
          this.checkHeight(doc);
          if (
            splittedText[i] !== String.fromCharCode(160) &&
            splittedText[i].length
          ) {
            this.yPos = this.yPos + this.lineHeight;
            doc.text(splittedText[i], 75, this.yPos);
          }
        }
      } else if (this.appInfoData.resourceUrInfolList.length <= 6) {
        this.yPos = this.yPos + this.lineHeight - 150;
        let img = document.createElement("img");
        img.src = `data:image/png;base64,${this.appInfoData.resourceUrInfolListData[index]}`;
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[0],
          "PNG",
          75,
          this.yPos,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[1],
          "PNG",
          142,
          this.yPos,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[2],
          "PNG",
          75,
          this.yPos + 48,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[3],
          "PNG",
          142,
          this.yPos + 48,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[4],
          "PNG",
          75,
          this.yPos + 96,
          63,
          47,
          undefined,
          "FAST"
        );
        doc.addImage(
          this.appInfoData.resourceUrInfolListData[5],
          "PNG",
          142,
          this.yPos,
          63,
          47,
          undefined,
          "FAST"
        );

        this.yPos = this.yPos + this.lineHeight + 130;
        this.checkHeight(doc);
        doc.setFontSize(18);
        doc.setTextColor(...pdfColor("hpDeeperGray"));
        doc.text("Description", 75, this.yPos);

        this.yPos = this.yPos + this.lineHeight - 5;
        doc.setFontSize(10);
        doc.setTextColor(...pdfColor("hpBlack"));
        let description = this.appInfoData.description.replaceAll(
          new RegExp(/[•\t+]/g),
          " "
        );
        let splittedText = doc.splitTextToSize(description, this.width - 85);
        for (let i = 0; i < splittedText.length; i++) {
          this.lineHeight =
            doc.getLineHeight(splittedText[0]) / doc.internal.scaleFactor;
          this.checkHeight(doc);
          if (
            splittedText[i] !== String.fromCharCode(160) &&
            splittedText[i].length
          ) {
            this.yPos = this.yPos + this.lineHeight;
            doc.text(splittedText[i], 75, this.yPos);
          }
        }
      }
    },
    checkHeight(doc) {
      if (this.yPos + this.lineHeight >= this.height - 57) {
        doc.addPage();
        this.yPos = 20;
      }
    },
    changeOrientation(value) {
      this.mode = value;
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 50px;
  height: 50px;
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.selected {
  border: solid $hpPrimary 5px;
}

p {
  margin: auto;
}
.btn {
  width: 6rem;
  height: 2rem;
}
.message {
  position: relative;
  text-align: left;
  margin-right: 400px;
}
.heading-msg {
  width: 100%;
  margin-left: 1.7%;
  font-size: 98%;
  padding: 0px 0px 0px 1px;
  color: $hpBlack;
  text-align: left;
}
.br {
  display: block;
  padding-right: 180px;
}
</style>
